module.exports = __webpack_public_path__ + "static/media/down_bg.83776add.png";